import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
  selector: 'elm-empty-state',
  templateUrl: './elm-empty-state.component.html',
  styleUrls: ['./elm-empty-state.component.scss'],
  host: { class: 'elm-empty-state' },
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ElmEmptyStateComponent {
  @Input() icon!: string;
  @Input() message!: string;
  @Input() title!: string;
}
